(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function formatAmount(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }

    const amount = cents / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: Shopify?.currency?.active || 'USD',
    }).format(amount);
  }

  function updateSaveBadge(badge, variant) {
    if (!badge || !variant) return;

    const format = badge.dataset.badgeFormat || 'percent';
    const compareAt = variant.compare_at_price;
    const price = variant.price;

    if (!compareAt || compareAt <= price) {
      badge.hidden = true;
      badge.classList.add('hidden');
      badge.textContent = '';
      return;
    }

    const saveCents = compareAt - price;
    const savePercent = Math.round((saveCents / compareAt) * 100);
    badge.textContent = format === 'amount' ? `${formatAmount(saveCents)}` : `-${savePercent}%`;
    badge.hidden = false;
    badge.classList.remove('hidden');
  }

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const sectionId = event?.data?.sectionId;
    const variant = event?.data?.variant;
    if (!sectionId || !variant) return;

    const badge = document.querySelector(`#SaveBadge-${sectionId}[data-save-badge]`);
    updateSaveBadge(badge, variant);
  });
})();
